import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types';

const API_URL = '/v2/parent-languages';

class ParentLanguagesService {
  static create(
    data: Record<string, unknown>,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<unknown>> {
    return axios.post(API_URL, data, config);
  }

  static delete(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<unknown> {
    return axios.delete(`${API_URL}/${id}`, config);
  }
}

export { ParentLanguagesService };
